import { render, staticRenderFns } from "./LandingPageLisa.vue?vue&type=template&id=9aaef650&scoped=true"
import script from "./LandingPageLisa.vue?vue&type=script&lang=js"
export * from "./LandingPageLisa.vue?vue&type=script&lang=js"
import style0 from "./LandingPageLisa.vue?vue&type=style&index=0&id=9aaef650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aaef650",
  null
  
)

export default component.exports